document.addEventListener('DOMContentLoaded', () => {
  const categoriesItems = document.querySelector('.page-body__column.is-main')
  const pageNav = document.querySelector('.page-nav')

  if (categoriesItems && pageNav) {
    // スクロール処理を再利用可能な関数にまとめる
    const scrollToElement = (element) => {
      const headerHeight = document.querySelector('.header').offsetHeight
      const rect = element.getBoundingClientRect()
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const position = rect.top + scrollTop - headerHeight
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      })
    }

    const headings = {
      h2: Array.from(categoriesItems.querySelectorAll('h2'))
    }

    // 既存のリンククリック時の処理
    pageNav.querySelectorAll('.page-nav__item-link.page-nav__item-link__internalLink').forEach((link) => {
      const dataType = link.getAttribute('data-type')
      if (!dataType || !headings[dataType]) return

      let matchedElement = null

      headings[dataType].forEach((heading) => {
        if (!heading.dataset.used && !matchedElement && heading.textContent.trim() === link.textContent.trim()) {
          matchedElement = heading
          heading.dataset.used = "true"
        }
      })

      if (matchedElement) {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          scrollToElement(matchedElement)
          // URLのハッシュを更新して、どの項目を見ているか分かりやすくする
          history.pushState(null, null, link.hash)
        })
      }
    })

    // 初期ロード時にURLのハッシュを見てスクロールする処理
    const hash = window.location.hash
    if (hash) {
      history.replaceState(null, null, ' ')

      try {
        const targetElementOnLoad = document.querySelector(hash)
        if (targetElementOnLoad) {
          // ページの描画が完全に終わってからスクロール位置を計算するため、少し遅延させる
          setTimeout(() => {
            // h2タグではなく、idが指定されたdiv要素に直接スクロールする
            scrollToElement(targetElementOnLoad)

            history.pushState(null, null, hash)
          }, 100)
        }
      } catch (e) {
        console.error('Invalid hash for querySelector:', e)
      }
    }
  }
})